// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
const defaultFonts = ({ fontFamily, fontSize }) => ({
  fontFamily: fontFamily.base,
  fontSize: fontSize.body,
  '-webkit-font-smoothing': 'antialiased',
});

export default defaultFonts;
